<template>
  <div v-if="tokenChecked">
    <v-form v-if="validToken == true">
      <p class="mb-3">{{ $t('Introduce tus datos') }}</p>
      <v-text-field
        :placeholder="$t('Email')"
        v-model="formdata.email"
        color="primary"
        autocomplete
        name="email"
        outline
        :label="$t('Email')"
        required
      ></v-text-field>

      <v-text-field
        :placeholder="$t('Nueva contraseña')"
        v-model="formdata.password"
        color="primary"
        autocomplete
        name="password"
        outline
        :label="$t('Nueva contraseña')"
        required
        type="password"
      ></v-text-field>

      <v-text-field
        :placeholder="$t('Confirma tu nueva contraseña')"
        v-model="formdata.password_confirmation"
        color="primary"
        autocomplete
        name="password_confirmation"
        outline
        :label="$t('Confirma tu nueva contraseña')"
        required
        type="password"
      ></v-text-field>

      <v-layout justify-center row>
        <v-flex xs6>
          <v-btn @click="submit" round large class="my-4 dark--text" color="primary">
            {{ $t('Guardar ') }}
          </v-btn>
        </v-flex>
      </v-layout>
      <p pb-1 mb-1 class="text-xs-center">
        {{ $t('¿Has recordado tu contraseña?') }}
      </p>
      <v-btn href="/login" flat color="primary">{{ $t('Login') }}</v-btn>
    </v-form>

    <template v-else>
      <h4 class="error my-3">
        {{
          $t(
            'El enlace para cambiar la contraseña no es válido o ha expirado. por favor, vuelve a solicitar un cambio de contraseña para obtener un enlace válido',
          )
        }}
      </h4>
      <v-btn flat color="primary" to="/password">
        {{ $t('Solicitar nuevo enlace') }}
      </v-btn>
    </template>
  </div>
</template>

<script>
import authApi from '../services/auth-api.js';
import { OG_CONFIG } from '@/services/api/config.js';
export default {
  data() {
    return {
      formdata: {
        email: '',
        password: '',
        password_confirmation: '',
        token: this.$route.params.token,
      },

      tokenChecked: false,
      validToken: false,
      imgLogin: OG_CONFIG.FRONT_URL + '/img/01_Login.jpg',
      imgLogo: OG_CONFIG.FRONT_URL + '/img/logo.png',
      msgInvalidToken: '',
    };
  },
  mounted() {
    this.checkValidTokenResetPassword();
  },
  methods: {
    submit() {
      authApi.resetNewPassword(this.formdata).then(res => {
        this.$router.push('/login');
      });
    },

    checkValidTokenResetPassword() {
      this.tokenChecked = false;
      authApi.checkTokenResetPassword(this.formdata.token).then(res => {
        // If token is valid show form setting property true
        if (res) {
          this.validToken = true;
        }
        this.tokenChecked = true;

        // If it is invalid set on msgInvalidToken the message received from server or redirect to login and show alert.
      });
    },
  },
};
</script>
